export default ({request}) => ({
  ecomAmzRecordOrderListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzRecordOrder/list',
      method: 'POST',
      data,
    })
  },
})
